// Time is derived from the deadline, including after tab suspension or reload.
export class FocusTimer{
  constructor({saved,onChange=()=>{},onFinish=()=>{},now=()=>Date.now() }={}){
    this.now=now;this.onChange=onChange;this.onFinish=onFinish;
    this.state={status:'idle',mode:'focus',duration:5,remainingMs:300000,endTime:null};
    if(saved&&typeof saved==='object'){
      const duration=Number(saved.duration);
      if(Number.isInteger(duration)&&duration>=1&&duration<=45){
        this.state.duration=duration;this.state.remainingMs=duration*60000;
        const validMode=['focus','break'].includes(saved.mode);
        const validStatus=['idle','running','paused','finished','break'].includes(saved.status);
        const validRemaining=Number.isFinite(saved.remainingMs)&&saved.remainingMs>=0&&saved.remainingMs<=2700000;
        const validDeadline=Number.isFinite(saved.endTime)&&saved.endTime>0&&saved.endTime<=this.now()+2700000;
        if(validMode&&validStatus&&validRemaining){
          const active=saved.status==='running'||saved.status==='break';
          if(!active||validDeadline)this.state={...this.state,status:saved.status,mode:saved.mode,remainingMs:saved.remainingMs,endTime:active?saved.endTime:null};
        }
      }
    }
    this.tick(false);
    this.interval=setInterval(()=>this.tick(),250);
  }
  get active(){return ['running','paused','break'].includes(this.state.status)}
  get snapshot(){return {...this.state}}
  emit(persist=true){this.onChange(this.snapshot,persist)}
  tick(notify=true){
    if(!['running','break'].includes(this.state.status))return;
    this.state.remainingMs=Math.max(0,this.state.endTime-this.now());
    if(this.state.remainingMs===0){
      this.state.status='finished';this.state.endTime=null;
      if(notify){this.emit();this.onFinish(this.state.mode)}
    }else if(notify)this.emit(false);
  }
  setDuration(value){
    if(this.active)return false;
    if(!Number.isInteger(value)||value<1||value>45)return false;
    this.state={status:'idle',mode:'focus',duration:value,remainingMs:value*60000,endTime:null};this.emit();return true;
  }
  start(){
    if(this.state.status!=='idle')return;
    this.state.status='running';this.state.endTime=this.now()+this.state.remainingMs;this.emit();
  }
  pause(){
    if(!['running','break'].includes(this.state.status))return;
    this.tick();if(this.state.status==='finished')return;
    this.state.status='paused';this.state.endTime=null;this.emit();
  }
  resume(){
    if(this.state.status!=='paused')return;
    this.state.status=this.state.mode==='break'?'break':'running';this.state.endTime=this.now()+this.state.remainingMs;this.emit();
  }
  reset(){this.state={status:'idle',mode:'focus',duration:this.state.duration,remainingMs:this.state.duration*60000,endTime:null};this.emit()}
  startBreak(){
    if(this.state.status!=='finished'||this.state.mode!=='focus')return;
    this.state={...this.state,status:'break',mode:'break',remainingMs:180000,endTime:this.now()+180000};this.emit();
  }
  complete(){this.state.status='finished';this.state.endTime=null;this.state.remainingMs=0;this.emit()}
  destroy(){clearInterval(this.interval)}
}
